import { isPlainObject } from 'lodash';
import { filterResolverKey as RESOLVER_KEY } from '@wix/wix-data-client-common-standalone';
const RESOLVER_VALUE = 'currentUser';
export const addCurrentUserResolver = () => {
    return { [RESOLVER_KEY]: RESOLVER_VALUE };
};
export const shouldResolveCurrentUser = (filterExpression) => isPlainObject(filterExpression) &&
    filterExpression[RESOLVER_KEY] === RESOLVER_VALUE;
//# sourceMappingURL=currentUserFilterResolver.js.map